import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
// import { TimePeriod } from "ngx-material-timepicker/libs/portal/src/material-timepicker/models/time-period.enum";
import { Subscription, forkJoin } from 'rxjs';
import { GraphChange } from 'libs/portal/src/models/GraphChange';
import { TIMEPERIODS, TimePeriod } from 'libs/portal/src/models/types/TimePeriods';
import { TimeFrame, TIMEFRAMES } from 'libs/portal/src/models/types/Timeframes';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { DashboardServer, ServerGroups } from '../../../interfaces/DashboardServer.interface';
import { TransactionResponse } from '../../../interfaces/TransactionStats.interface';
import { GraphModalComponent } from 'libs/portal/src/modules/tools/graph-modal/graph-modal.component';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';

@Component({
  selector: 'app-relay-transaction-detail',
  templateUrl: './relay-transaction-detail.component.html',
  styleUrls: ['./relay-transaction-detail.component.scss'],
})
export class RelayTransactionDetailComponent implements OnInit, OnDestroy {
  refreshInterval: ReturnType<typeof setTimeout>;

  constructor(
    public tools: ToolsService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private auth: UserRightsService,
  ) {}

  defaultGraphQueryParams = {
    count: 100,
    offset: 0,
    search: '',
    orderBy: 'T',
    desc: false,
  };

  graphColors = ['#0ede26', '#488f31', '#2031de', '#8f068a', '#de6d27', '#8f2246', '#895cde', '#8f5e15', '#603232', '#FB5607'];

  now = new Date();
  defaultServerRequest = {
    GroupName: null,
    TimeUnit: 1,
    TimePeriod: 1,
    ServerID: null,
    ServerLinkName: null,
    OutgoingLinkPort: null,
  };
  showDateRange = false;

  timeOptions = [
    {
      name: 'Minutes',
      value: 2,
    },
    {
      name: 'Hours',
      value: 3,
    },
    {
      name: 'Days',
      value: 4,
    },
  ];

  timeFrameOptions = [2, 3, 4];
  timePeriodOptions = [1, 2, 3, 4, 6, 8, 9];
  serverData: TransactionResponse[];
  currentTimeFrame = 3;
  currentTimePeriod = 2;
  currentTimeInterval = 1;
  transactionSum = 0;
  tickAmount = 0;
  tempServerData: TransactionResponse[] = [];
  incomingServerLinks: any[] = [
    {
      Label: 'All',
      ID: -1,
    },
  ];
  outGoingServerLinks: any[] = [
    {
      Label: 'All',
      ID: -1,
    },
  ];

  detailsNavOptions: NavProperty[] = [
    {
      Text: '',
      OriginalText: '',
      Links: [],
    },
  ];
  loading = false;

  linkDescription: string = '';

  startOfMonth: Date = this.tools.GetStartOfMonth(new Date());
  endOfMonth: Date = this.tools.GetEndOfMonth();
  defaultTimeFrame: TimeFrame = TIMEFRAMES.find((elem) => elem.iD == this.currentTimeFrame);
  defaultTimePeriod: TimePeriod = TIMEPERIODS.find((elem) => elem.iD == this.currentTimePeriod);
  defaultInterval = 1;
  currentStartDate: string = null;
  currentEndDate: string = null;
  outageSelected = false;
  hideOutages = false;
  intervalDisabled = false;
  timeFrameDisabled = false;
  dashboardDetails: any[] = [
    {
      header: 'Total Transactions',
      value: 0,
    },
    {
      header: 'Total Success Transactions',
      value: 0,
    },
    {
      header: 'Total Failed Transactions',
      value: 0,
    },
    {
      header: 'Total Null Transactions',
      value: 0,
    },
    {
      header: 'Total Bank Outages',
      value: 0,
    },
    {
      header: 'Distinct IPs',
      value: 0,
    },
    {
      header: 'Number of APNs',
      value: 0,
    },
    {
      header: 'Total Tx',
      value: 0,
    },
    {
      header: 'Total Rx',
      value: 0,
    },
  ];

  TxGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.TxGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Tx (in bytes)',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Data (in bytes)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  RxGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.RxGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Rx (in bytes)',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Data (in bytes)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  ConcurrentConnectionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.ConcurrentGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Active connections per interval',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Number of Connections',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  STransactionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.SuccessGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Successful Transactions',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Number of Transactions',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  FTransactionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.FailGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Failed Transactions',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Number of Transactions',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    IsReady: false,
    xAxisType: 'datetime',
  };

  OTransactionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.OutageGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Outages',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Number of Transactions',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  NTransactionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.NullTransactionsGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Null Transactions',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Number of Transactions',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  TotalTransactionsGraphConfig: GraphChange = {
    Callback: null,
    Transformer: this.TotalTransactionsGraphFormatter,
    StartDate: this.startOfMonth.toISOString(),
    EndDate: this.endOfMonth.toISOString(),
    TimeFrame: this.defaultTimeFrame,
    Timeperiod: this.defaultTimePeriod,
    Interval: this.defaultInterval,
    Data: {
      GraphTitle: 'Total Transactions',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: 'Data (in bytes)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: this.defaultGraphQueryParams,
    xAxisType: 'datetime',
    IsReady: false,
    tools: this.tools,
  };

  serverLinkID: number;
  serverID: number;
  outgoingLinkID: number;
  groupName: string;
  allServers: DashboardServer[] = [];
  currentlySelected: 'group' | 'server' | 'serverLink' | 'outgoingLink';

  authSubscription: Subscription;
  obfuscateDetails = false;

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  ngOnInit() {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.loading = true;
        this.allServers = [];
        this.serverData = [];
        this.tempServerData = [];
        this.detailsNavOptions = [
          {
            Text: '',
            OriginalText: '',
            Links: [],
          },
        ];
      }
      this.pageSetup();
    });
  }

  pageSetup() {
    let storageItem = sessionStorage.getItem('relayDashboardSelection');
    storageItem = JSON.parse(storageItem);
    this.groupName = storageItem['groupName'];
    if (this.groupName == '') {
      this.router.navigate(['Relay']);
    }

    let serverID = parseInt(storageItem['serverName']);
    let isGroup = false;
    if (storageItem['isGroup']) {
      isGroup = true;
      if (this.groupName == 'Unassigned') {
        this.getInitialData(this.currentTimeFrame, '', null, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
      } else {
        this.getInitialData(this.currentTimeFrame, this.groupName, null, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
      }
      this.currentlySelected = 'group';
    } else {
      this.getInitialData(this.currentTimeFrame, null, serverID, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
      this.currentlySelected = 'server';
    }
    this.detailsNavOptions[0].Text = this.obfuscateDetails ? this.tools.Obfuscate(this.groupName, 'Group ', 4) : this.groupName;
    this.populateSideNav(isGroup, serverID);
  }

  refreshPageEveryXMinutes(value: number = 60 * 5) {
    // value in seconds
    this.refreshInterval = setInterval(() => {
      this.now = new Date();
      this.updateGraph();
    }, value * 1000);
  }

  populateSideNav(isGroup: boolean, serverID: number) {
    this.genericService.GET(this.endpoints.GET_RELAY_GROUPS).subscribe(
      (data: Object) => {
        let serverArray = data['body'];

        serverArray.forEach((element: ServerGroups) => {
          if (element.GroupName == this.groupName) {
            if (isGroup) {
              element.Servers.forEach((server: DashboardServer) => {
                this.detailsNavOptions[0].Links.push({
                  Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                  ID: server.ID,
                  Active: false,
                });
              });
            } else {
              element.Servers.forEach((server: DashboardServer) => {
                if (server.ID == serverID) {
                  this.detailsNavOptions[0].Links.push({
                    Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                    ID: server.ID,
                    Active: true,
                  });
                } else {
                  this.detailsNavOptions[0].Links.push({
                    Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                    ID: server.ID,
                    Active: false,
                  });
                }
              });
            }
          } else if (element.GroupName == '' && this.groupName == 'Unassigned') {
            if (isGroup) {
              element.Servers.forEach((server: DashboardServer) => {
                this.detailsNavOptions[0].Links.push({
                  Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                  ID: server.ID,
                  Active: false,
                });
              });
            } else {
              element.Servers.forEach((server: DashboardServer) => {
                if (server.ID == serverID) {
                  this.detailsNavOptions[0].Links.push({
                    Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                    ID: server.ID,
                    Active: true,
                  });
                } else {
                  this.detailsNavOptions[0].Links.push({
                    Text: this.obfuscateDetails ? this.tools.Obfuscate(server.Name, 'Server ', 4) : server.Name,
                    ID: server.ID,
                    Active: false,
                  });
                }
              });
            }
          }
        });
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  RxGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.rx.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.rx[i]).forEach(([key, value]) => {
        value[0] = value[0] ? value[0] : 0;

        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0].toFixed(2)]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  TxGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.tx.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.tx[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0].toFixed(2)]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  ConcurrentGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.c.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.c[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0].toFixed(2)]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  SuccessGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.s.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.s[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0]]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  FailGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.f.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.f[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0]]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  OutageGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.o.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.o[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0]]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  NullTransactionsGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];
    for (let i = 0; i < c.UnprocessedData.n.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.n[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0]]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  TotalTransactionsGraphFormatter(c: GraphChange) {
    let labels = [];
    let currTimestamp = null;
    c.Data.SeriesData = [];

    for (let i = 0; i < c.UnprocessedData.t.length; i++) {
      c.Data.SeriesData.push({
        name: c.GraphDashboard.obfuscateDetails ? c.GraphDashboard.tools.Obfuscate(c.UnprocessedData.data[i].L, 'Link ', 4) : c.UnprocessedData.data[i].L,
        data: [],
      });
      Object.entries(c.UnprocessedData.t[i]).forEach(([key, value]) => {
        if (currTimestamp == null || key != currTimestamp) {
          labels.push(c.GraphDashboard.tools.FormatDateTimeFromDate(c.GraphDashboard.tools.ParseAPIDateWithTimezone(key)));
          currTimestamp = key;
        }
        value[0] = value[0] ? value[0] : 0;
        c.Data.SeriesData[i].data.push([c.tools.getDateFromString(key), value[0]]);
      });
    }
    c.Data.XAxisCategories = labels;
  }

  getDropdownOptions(gN, sN, sL) {
    let objectToSend = {
      GroupName: gN,
      ServerID: sN,
      ServerLinkID: sL,
    };

    this.genericService.POST(this.endpoints.GET_RELAY_ENTITIES, objectToSend).subscribe((result: any) => {
      result = result['body'];
      if (sN != null) {
        this.incomingServerLinks = [
          {
            Label: 'All',
            ID: -1,
          },
        ];
        result.forEach((element) => {
          this.incomingServerLinks.push({
            Label: this.obfuscateDetails ? this.tools.Obfuscate(element.L, '', 4) : element.L,
            ID: element.ID,
            Description: element.D,
          });
        });
      } else if (sL != null) {
        this.outGoingServerLinks = [
          {
            Label: 'All',
            ID: -1,
          },
        ];
        result.forEach((element) => {
          this.outGoingServerLinks.push({
            Label: this.obfuscateDetails ? this.tools.Obfuscate(element.L, '', 4) : element.L,
            ID: element.ID,
          });
        });
      }
    });
  }

  getInitialData(tF: number, gN: string, sN: number, sL: number, oL: number, tP: number, tI: number, sD: string, eD: string) {
    this.loading = true;
    this.STransactionsGraphConfig.IsReady = false;
    this.FTransactionsGraphConfig.IsReady = false;
    this.ConcurrentConnectionsGraphConfig.IsReady = false;
    this.TxGraphConfig.IsReady = false;
    this.RxGraphConfig.IsReady = false;
    this.OTransactionsGraphConfig.IsReady = false;
    this.NTransactionsGraphConfig.IsReady = false;
    this.TotalTransactionsGraphConfig.IsReady = false;

    let endpoint1 = this.genericService.POST(this.endpoints.GET_SERVER_STATS, {
      GroupName: gN,
      TimeInterval: tI,
      TimeUnit: tF,
      TimePeriod: tP == 9 ? null : tP,
      ServerID: sN,
      ServerLinkID: sL,
      OutgoingLinkID: oL,
      StartDate: sD ? this.getDateFromString(sD) : null,
      EndDate: eD ? this.getDateFromString(eD) : null,
    });

    // let endpoint2 = this.genericService.GET(this.endpoints.GET_RELAY_GROUPS);

    let endpoint2 = this.genericService.POST(this.endpoints.GET_TRANSACTION_TILES, {
      GroupName: gN,
      TimeInterval: tI,
      TimeUnit: tF,
      TimePeriod: tP == 9 ? null : tP,
      ServerID: sN,
      ServerLinkID: sL,
      OutgoingLinkID: oL,
      StartDate: sD ? this.getDateFromString(sD) : null,
      EndDate: eD ? this.getDateFromString(eD) : null,
    });

    forkJoin([endpoint1, endpoint2]).subscribe(([results, tiles]) => {
      this.tempServerData = [];

      this.serverData = results['body'] as any;
      // let tileValue = tiles;
      let tileValue = tiles['body'];

      this.dashboardDetails[0].value = tileValue.TotalTransactions.toLocaleString() ?? 0;
      this.dashboardDetails[1].value = tileValue.TotalSuccessful.toLocaleString() ?? 0;
      this.dashboardDetails[2].value = tileValue.TotalFailed.toLocaleString() ?? 0;
      this.dashboardDetails[3].value = tileValue.TotalNull.toLocaleString() ?? 0;
      this.dashboardDetails[4].value = tileValue.TotalBankOutages.toLocaleString() ?? 0;
      this.dashboardDetails[5].value = tileValue.DistinctIPs.toLocaleString() ?? 0;
      this.dashboardDetails[6].value = tileValue.NumAPNs.toLocaleString() ?? 0;
      this.dashboardDetails[7].value = this.tools.FormatBundleUsage(tileValue.TotalTx ?? 0);
      this.dashboardDetails[8].value = this.tools.FormatBundleUsage(tileValue.TotalRx ?? 0);

      if (results != null) {
        let transactions = results['body'] as TransactionResponse[];
        this.transactionSum = 0;

        if (transactions) {
          let processedData = this.processData(transactions);

          //Success graph config

          this.STransactionsGraphConfig = {
            Callback: null,
            Transformer: this.SuccessGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Successful Transactions (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Number of Transactions',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            GraphDashboard: this,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            xAxisType: 'datetime',
            tools: this.tools,
            TickAmount: this.tickAmount,
          };
          this.STransactionsGraphConfig.UnprocessedData = processedData;
          this.STransactionsGraphConfig.IsReady = true;
          if (this.STransactionsGraphConfig.Callback) {
            this.STransactionsGraphConfig.Callback();
          }

          /////////////////////////////////////////////////////////////////////////

          //Fail Graph Config

          this.FTransactionsGraphConfig = {
            Callback: null,
            Transformer: this.FailGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Failed Transactions (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Number of Transactions',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            xAxisType: 'datetime',
            GraphDashboard: this,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };
          this.FTransactionsGraphConfig.UnprocessedData = processedData;
          this.FTransactionsGraphConfig.IsReady = true;
          if (this.FTransactionsGraphConfig.Callback) {
            this.FTransactionsGraphConfig.Callback();
          }

          //TX Graph Config

          this.TxGraphConfig = {
            Callback: null,
            Transformer: this.TxGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Tx (in bytes) (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Data (in bytes)',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            xAxisType: 'datetime',
            GraphDashboard: this,
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.TxGraphConfig.UnprocessedData = processedData;
          this.TxGraphConfig.IsReady = true;
          if (this.TxGraphConfig.Callback) {
            this.TxGraphConfig.Callback();
          }

          /////////////////////////////////////////////////////////////////////

          //RX Graph Config

          this.RxGraphConfig = {
            Callback: null,
            Transformer: this.RxGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Rx (in bytes) (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Data (in bytes)',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            xAxisType: 'datetime',
            GraphDashboard: this,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.RxGraphConfig.UnprocessedData = processedData;
          this.RxGraphConfig.IsReady = true;
          if (this.RxGraphConfig.Callback) {
            this.RxGraphConfig.Callback();
          }

          /////////////////////////////////////////////////////////////////////

          //Concurrent Connections Graph Config

          this.ConcurrentConnectionsGraphConfig = {
            Callback: null,
            Transformer: this.ConcurrentGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Active Connections Per Interval (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Number of Connections',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            xAxisType: 'datetime',
            GraphDashboard: this,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.ConcurrentConnectionsGraphConfig.UnprocessedData = processedData;
          this.ConcurrentConnectionsGraphConfig.IsReady = true;
          if (this.ConcurrentConnectionsGraphConfig.Callback) {
            this.ConcurrentConnectionsGraphConfig.Callback();
          }

          /////////////////////////////////////////////////////////////////////////

          //Null Transaction Graph Config

          this.NTransactionsGraphConfig = {
            Callback: null,
            Transformer: this.NullTransactionsGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Null Transactions (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Number of Connections',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            xAxisType: 'datetime',
            GraphDashboard: this,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.NTransactionsGraphConfig.UnprocessedData = processedData;
          this.NTransactionsGraphConfig.IsReady = true;
          if (this.NTransactionsGraphConfig.Callback) {
            this.NTransactionsGraphConfig.Callback();
          }

          /////////////////////////////////////////////////////////////////////////

          //Outage Graph Config

          this.OTransactionsGraphConfig = {
            Callback: null,
            Transformer: this.OutageGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Bank Outages (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Number of Connections',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            GraphDashboard: this,
            xAxisType: 'datetime',
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphQueryParams: this.defaultGraphQueryParams,
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.OTransactionsGraphConfig.UnprocessedData = processedData;
          this.OTransactionsGraphConfig.IsReady = true;
          if (this.OTransactionsGraphConfig.Callback) {
            this.OTransactionsGraphConfig.Callback();
          }
          this.outageSelected = this.hideOutages;

          /////////////////////////////////////////////////////////////////////////

          // Total Transaction //////////////////////////////////////////////
          this.TotalTransactionsGraphConfig = {
            Callback: null,
            Transformer: this.TotalTransactionsGraphFormatter,
            StartDate: this.startOfMonth.toISOString(),
            EndDate: this.endOfMonth.toISOString(),
            TimeFrame: TIMEFRAMES.find((elem) => elem.iD == tF),
            Timeperiod: TIMEPERIODS.find((elem) => elem.iD == tP),
            Interval: this.defaultInterval,
            Data: {
              GraphTitle: `Total Transactions (every  ${this.currentTimeInterval} ${this.defaultTimeFrame.name} ${this.defaultTimePeriod.name})`,
              GraphType: 'line',
              SeriesData: [],
              XAxisLabel: 'Time',
              YAxisLabel: 'Data (in bytes)',
              XAxisCategories: [],
            },
            UnprocessedData: null,
            GraphHandler: null,
            // colors: ["#0ede26", "#488f31", "#2031de", "#8f068a", "#de6d27", "#8f2246", "#895cde", "#8f5e15","#603232", "#FB5607"],
            GraphDashboard: this,
            GraphQueryParams: this.defaultGraphQueryParams,
            xAxisType: 'datetime',
            IsReady: false,
            tools: this.tools,
            TickAmount: this.tickAmount,
          };

          this.TotalTransactionsGraphConfig.UnprocessedData = processedData;
          this.TotalTransactionsGraphConfig.IsReady = true;
          if (this.TotalTransactionsGraphConfig.Callback) {
            this.TotalTransactionsGraphConfig.Callback();
          }
          this.outageSelected = this.hideOutages;
        }
      }
      this.loading = false;
    });
  }

  updateGraph() {
    switch (this.currentlySelected) {
      case 'group':
        this.getInitialData(
          this.currentTimeFrame,
          this.groupName == 'Unassigned' ? '' : this.groupName,
          null,
          null,
          null,
          this.currentTimePeriod,
          this.currentTimeInterval,
          this.currentStartDate,
          this.currentEndDate,
        );
        break;
      case 'server':
        this.getInitialData(this.currentTimeFrame, null, this.serverID, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
        break;
      case 'serverLink':
        if (this.serverLinkID == -1) {
          this.getInitialData(this.currentTimeFrame, null, this.serverID, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
        } else {
          this.getInitialData(
            this.currentTimeFrame,
            null,
            null,
            this.serverLinkID,
            null,
            this.currentTimePeriod,
            this.currentTimeInterval,
            this.currentStartDate,
            this.currentEndDate,
          );
        }
        break;
      case 'outgoingLink':
        if (this.outgoingLinkID == -1) {
          this.getInitialData(
            this.currentTimeFrame,
            null,
            null,
            this.serverLinkID,
            null,
            this.currentTimePeriod,
            this.currentTimeInterval,
            this.currentStartDate,
            this.currentEndDate,
          );
        } else {
          this.getInitialData(
            this.currentTimeFrame,
            null,
            null,
            null,
            this.outgoingLinkID,
            this.currentTimePeriod,
            this.currentTimeInterval,
            this.currentStartDate,
            this.currentEndDate,
          );
        }
        break;
    }
  }

  pageClicked(item: NavAttribute) {
    if (this.serverID == item.ID && this.currentlySelected != 'group') {
      return;
    }
    this.currentlySelected = 'server';
    this.hideOutages = false;
    this.loading = true;
    this.showDateRange = false;
    this.serverID = item.ID;
    this.serverLinkID = -1;
    this.detailsNavOptions[0].Links.forEach((element: NavAttribute) => {
      element['Active'] = false;
    });
    this.incomingServerLinks = [
      {
        Label: 'All',
        ID: -1,
      },
    ];
    this.outGoingServerLinks = [
      {
        Label: 'All',
        ID: -1,
      },
    ];
    this.currentTimeFrame = -1;
    this.getDropdownOptions(null, this.serverID, null);

    setTimeout(() => {
      this.currentTimeFrame = 3;
      this.currentTimeInterval = 1;
      if (this.currentTimePeriod != 9) {
        this.currentTimePeriod = 2;
        this.showDateRange = false;
      } else {
        this.currentTimePeriod = 9;
      }
      this.defaultTimeFrame = TIMEFRAMES.find((elem) => elem.iD == this.currentTimeFrame);
      this.defaultTimePeriod = TIMEPERIODS.find((elem) => elem.iD == this.currentTimePeriod);
      this.getInitialData(this.currentTimeFrame, null, this.serverID, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
    });
    item['Active'] = true;
  }

  transactionChanged(event: number, isIncoming: boolean) {
    if (isIncoming) {
      this.currentlySelected = 'serverLink';
      this.serverLinkID = event;
      this.outgoingLinkID = -1;
      this.outGoingServerLinks = [
        {
          Label: 'All',
          ID: -1,
        },
      ];
      if (event == -1) {
      } else {
        this.linkDescription = this.incomingServerLinks.find((val) => val.ID == this.serverLinkID).Description;
        this.getDropdownOptions(null, null, event);
      }
    } else {
      this.currentlySelected = 'outgoingLink';
      this.outgoingLinkID = event;
      this.checkForOutage(event);

      if (this.tempServerData.length == 0) {
        this.tempServerData = JSON.parse(JSON.stringify(this.serverData));
        this.serverData = [this.tempServerData.filter((x) => x.ID == event)[0]];
      } else {
        this.serverData = [this.tempServerData.filter((x) => x.ID == event)[0]];
      }
    }
  }

  selectGroup() {
    this.hideOutages = false;
    this.currentlySelected = 'group';
    this.detailsNavOptions[0].Links.forEach((element: NavAttribute) => {
      element.Active = false;
    });

    this.currentTimeFrame = -1;
    setTimeout(() => {
      this.currentTimeFrame = 3;
      this.currentTimeInterval = 1;
      if (this.currentTimePeriod != 9) {
        this.currentTimePeriod = 2;
        this.showDateRange = false;
        this.currentStartDate = null;
        this.currentEndDate = null;
      } else {
        this.currentTimePeriod = 9;
      }
      this.defaultTimeFrame = TIMEFRAMES.find((elem) => elem.iD == this.currentTimeFrame);
      this.defaultTimePeriod = TIMEPERIODS.find((elem) => elem.iD == this.currentTimePeriod);
      if (this.groupName == 'Unassigned') {
        this.getInitialData(this.currentTimeFrame, '', null, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
      } else {
        this.getInitialData(this.currentTimeFrame, this.groupName, null, null, null, this.currentTimePeriod, this.currentTimeInterval, this.currentStartDate, this.currentEndDate);
      }
    });
  }

  timeVariableChanged(event: any, option: number) {
    if (option == 1) {
      this.currentTimeInterval = parseInt(event);
    } else if (option == 2) {
      if (event.iD == 9) {
        this.showDateRange = true;
      } else {
        this.currentEndDate = '';
        this.currentStartDate = '';
        this.showDateRange = false;
      }
      this.currentTimePeriod = event.iD;
    } else if (option == 3) {
      this.currentTimeFrame = event.iD;
    }

    if (this.currentTimePeriod == 1) {
      this.currentTimeInterval = 1;
      this.currentTimeFrame = 2;
      this.intervalDisabled = true;
      this.timeFrameDisabled = true;
    } else {
      this.intervalDisabled = false;
      this.timeFrameDisabled = false;
    }

    this.defaultInterval = this.currentTimeInterval;
    this.defaultTimeFrame = TIMEFRAMES.find((elem) => elem.iD == this.currentTimeFrame);
    this.defaultTimePeriod = TIMEPERIODS.find((elem) => elem.iD == this.currentTimePeriod);

    if (this.currentlySelected == 'group' && event.iD != 9) {
      this.getInitialData(
        this.currentTimeFrame,
        this.groupName == 'Unassigned' ? '' : this.groupName,
        null,
        null,
        null,
        this.currentTimePeriod,
        this.currentTimeInterval,
        this.currentStartDate,
        this.currentEndDate,
      );
    }
  }

  checkForOutage(id: number) {
    let selected = this.outGoingServerLinks.find((x) => {
      return id === parseInt(x['ID']);
    });

    if (selected.Label == 'Outage') {
      this.hideOutages = true;
    } else {
      this.hideOutages = false;
    }
  }

  processData(data: any) {
    // type 1 = rx 2 = tx 3 = conn 4 = success 5 = fail
    let rXMap = {};
    let tXMap = {};
    let SMap = {};
    let FMap = {};
    let CMap = {};
    let OMap = {};
    let NMap = {};
    let TTMap = {};

    let rxData = [];
    let txData = [];
    let cData = [];
    let sData = [];
    let fData = [];
    let oData = [];
    let nData = [];
    let tData = [];

    let tickAmount = 0;
    data.forEach((trans) => {
      tickAmount = 0;
      trans.S.forEach((element) => {
        tickAmount++;
        if (rXMap[element.T] == null) {
          element.Rx = element.Rx ? element.Rx : 0;
          rXMap[element.T] = [element.Rx];
        } else {
          element.Rx = element.Rx ? element.Rx : 0;
          rXMap[element.T][0] = rXMap[element.T][0] + element.Rx;
        }

        if (tXMap[element.T] == null) {
          element.Tx = element.Tx ? element.Tx : 0;
          tXMap[element.T] = [element.Tx];
        } else {
          element.Tx = element.Tx ? element.Tx : 0;
          tXMap[element.T][0] = tXMap[element.T][0] + element.Tx;
        }

        if (CMap[element.T] == null) {
          element.C = element.C ? element.C : 0;
          CMap[element.T] = [element.C];
        } else {
          element.C = element.C ? element.C : 0;
          CMap[element.T][0] = CMap[element.T][0] + element.C;
        }

        if (SMap[element.T] == null) {
          element.S = element.S ? element.S : 0;
          SMap[element.T] = [element.S];
        } else {
          element.S = element.S ? element.S : 0;
          SMap[element.T][0] = SMap[element.T][0] + element.S;
        }

        if (FMap[element.T] == null) {
          element.F = element.F ? element.F : 0;
          FMap[element.T] = [element.F];
        } else {
          element.F = element.F ? element.F : 0;
          FMap[element.T][0] = FMap[element.T][0] + element.F;
        }

        if (OMap[element.T] == null) {
          element.O = element.O ? element.O : 0;
          OMap[element.T] = [element.O];
        } else {
          element.O = element.O ? element.O : 0;
          OMap[element.T][0] = OMap[element.T][0] + element.O;
        }

        if (NMap[element.T] == null) {
          element.N = element.N ? element.N : 0;
          NMap[element.T] = [element.N];
        } else {
          element.N = element.N ? element.N : 0;
          NMap[element.T][0] = NMap[element.T][0] + element.N;
        }

        if (TTMap[element.T] == null) {
          element.F = element.F ? element.F : 0;
          element.S = element.S ? element.S : 0;
          element.N = element.N ? element.N : 0;
          TTMap[element.T] = [element.S + element.F + element.N];
        } else {
          element.F = element.F ? element.F : 0;
          element.S = element.S ? element.S : 0;
          element.N = element.N ? element.N : 0;
          TTMap[element.T][0] = TTMap[element.T][0] + element.S + element.F + element.N;
        }
      });

      rxData.push(rXMap);
      txData.push(tXMap);
      cData.push(CMap);
      sData.push(SMap);
      fData.push(FMap);
      oData.push(OMap);
      nData.push(NMap);
      tData.push(TTMap);
      rXMap = {};
      tXMap = {};
      CMap = {};
      SMap = {};
      FMap = {};
      NMap = {};
      OMap = {};
      TTMap = {};
    });

    this.tickAmount = this.getTicks(tickAmount - 1);

    return {
      rx: rxData,
      tx: txData,
      c: cData,
      s: sData,
      f: fData,
      o: oData,
      n: nData,
      t: tData,
      data: data,
    };
  }

  enlargeGraph(type: string, event: any) {
    event.stopPropagation();
    let data = {};

    switch (type) {
      case 'Rx':
        data = this.RxGraphConfig;
        break;

      case 'Tx':
        data = this.TxGraphConfig;
        break;

      case 'Conn':
        data = this.ConcurrentConnectionsGraphConfig;
        break;

      case 'Fail':
        data = this.FTransactionsGraphConfig;
        break;

      case 'Success':
        data = this.STransactionsGraphConfig;
        break;

      case 'Null':
        data = this.NTransactionsGraphConfig;
        break;

      case 'Outage':
        data = this.OTransactionsGraphConfig;
        break;

      case 'TotalTrans':
        data = this.TotalTransactionsGraphConfig;
        break;
    }

    this.dialog.open(GraphModalComponent, {
      width: '100%',
      height: '70%',
      maxWidth: '90vw',
      data: data,
    });
  }

  getDateFromString(stringDate: string) {
    let convertedDate = this.changeDateFormat(stringDate);
    let date = new Date(convertedDate);
    let offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offset);

    return date;
  }

  changeDateFormat(dateString: string): string {
    const [day, month, year] = dateString.split('/');
    return `${month}/${day}/${year}`;
  }

  convertDateFormat(dateString: string): string {
    const parts = dateString.split('/');
    const day = parts[1];
    const month = parts[0];
    const year = parts[2];

    return `${day}-${month}-${year}`;
  }

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.currentEndDate = dateRangeEnd.value;
    this.currentStartDate = dateRangeStart.value;

    if (this.currentlySelected == 'group') {
      this.getInitialData(
        this.currentTimeFrame,
        this.groupName == 'Unassigned' ? '' : this.groupName,
        null,
        null,
        null,
        this.currentTimePeriod,
        this.currentTimeInterval,
        this.currentStartDate,
        this.currentEndDate,
      );
    }
  }

  getTicks(totalTicks: number) {
    for (let i = 8; i < 100; i++) {
      if (totalTicks % i == 0) {
        return i;
      }
    }
    return totalTicks;
  }

  onRefreshSettingsChanged(refreshSetting: number) {
    // refreshSetting <= 0 -> disabled
    // refreshSetting > 0 -> enabled
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    this.refreshInterval = null;
    if (refreshSetting != null && refreshSetting > 0) {
      this.refreshPageEveryXMinutes(refreshSetting);
    }
  }
}

export interface NavProperty {
  Text: string;
  OriginalText: string;
  Links: NavAttribute[];
}

export interface NavAttribute {
  ID: number;
  Text: string;
  Active: boolean;
}
